<script setup>
import GuideMobile1 from '~/assets/img/guide/GuideMobile1.svg'
import GuideMobile2 from '~/assets/img/guide/GuideMobile2.svg'
import GuideMobile3 from '~/assets/img/guide/GuideMobile3.svg'
import GuideMobile4 from '~/assets/img/guide/GuideMobile4.svg'
import GuideDesktop1 from '~/assets/img/guide/GuideDesktop1.svg'
import GuideDesktop2 from '~/assets/img/guide/GuideDesktop2.svg'
import GuideDesktop3 from '~/assets/img/guide/GuideDesktop3.svg'

import Logo from '~/assets/img/logo-icon.svg'
import InstallDesktop from '~/assets/img/install-desktop.svg'
import InstallDesktopBlack from '~/assets/img/install-desktop-black.svg'

import AddToHome from '~/assets/img/addToHome.svg'
import VerticalDots from '~/assets/img/verticalDots.svg'
import info from './Icons/info.vue'
import {useElementSize} from '@vueuse/core'

const {$_} = useNuxtApp()

const sectionRef = ref(null)
const {width: elwidth} = useElementSize(sectionRef)
const userStore = useUserStore()

// Guides for different platforms
const desktopGuide = [
  {
    text: $_('guide.desktop.step_one', "1. Nahoře v liště prohlížeče klikněte na ikonu "),
    img: GuideDesktop1,
    buttonLikeImg: InstallDesktopBlack,
    buttonLikeText: $_('guide.desktop.step_one_info', 'Nainstalovat aplikaci')
  },
  {
    text: $_('guide.desktop.step_two', "2. V dialogovém okně klikněte na tlačítko"),
    img: GuideDesktop2,
    buttonLikeImg: null,
    buttonLikeText: $_('guide.desktop.step_two_info', 'Instalovat')
  },
  {
    text: $_('guide.desktop.step_three', "3. Aplikaci nyní spustíte z plochy svého počítače"),
    img: GuideDesktop3,
    buttonLikeImg: Logo,
    buttonLikeText: null
  },
]
const mobileGuide = [
  {
    text: $_('guide.mobile.step_one', "1. Na horní liště klikněte na ikonu tří teček"),
    img: GuideMobile1,
    buttonLikeImg: VerticalDots,
    buttonLikeText: null
  },
  {
    text: $_('guide.mobile.step_two', "2. V rozbalovacím menu klikněte na tlačítko"),
    img: GuideMobile2,
    buttonLikeImg: AddToHome,
    buttonLikeText: $_('guide.mobile.step_two_info', 'Přidat na plochu')
  },
  {
    text: $_('guide.mobile.step_three', "3. V dialogovém okně klikněte na tlačítko"),
    img: GuideMobile3,
    buttonLikeImg: null,
    buttonLikeText: $_('guide.mobile.step_three_info', 'Instalovat')
  },
  {
    text: $_('guide.mobile.step_four', "4. Aplikaci spustíte snadno ze svého mobilu"),
    img: GuideMobile4,
    buttonLikeImg: Logo,
    buttonLikeText: null
  },
]

// Reactive state
const slide = ref(0)
const showButton = ref(false)
const guide = ref([])

let deferredPrompt = null
const warningBrowserSpecificMessege = ref(false)

// Detect PWA installability and determine the guide
onMounted(() => {
  console.log('Mounted: Checking PWA installability and determining guide...')
  deferredPrompt = userStore.pwaInstallEvent; // Get the saved event from the store
  // If is already installed, no need to show the button or guide
  if (isAlreadyInstalled()) {
    console.log('App is already installed. No install button or guide needed.')
    emits('close')
    return
  }
  //show button
  shouldShowButton(true)

  console.log('Choosing guide and warning message based on user agent...')

  determineGuide()
  showWarningMessege()
});

function isAlreadyInstalled() {
  if (window.matchMedia('(display-mode: standalone)').matches) {
    console.log('App is installed.')
    showButton.value = false
    guide.value = []
    return true
  }
}

function shouldShowButton(tryAgain = false) {
  if (!deferredPrompt && tryAgain) {
    setTimeout(() => {
      deferredPrompt = userStore.pwaInstallEvent; // Get the saved event from the store
      shouldShowButton()
    }, 1000)
    return
  }
  if ('serviceWorker' in navigator && 'onbeforeinstallprompt' in window && deferredPrompt) {
    console.log('PWA installation is supported. Showing install button.')
    showButton.value = true
  } else {
    showButton.value = false
  }
}


function determineGuide() {
  const userAgentData = navigator.userAgentData || null;
  const userAgent = navigator.userAgent;
  const isMobile = userAgentData?.mobile || /Mobi|Android/i.test(userAgent);

  console.log(`User Agent: ${userAgent}`);
  console.log(`Is Mobile: ${isMobile}`);

  if (isMobile) {
    console.log('Detected mobile device!');
    guide.value = mobileGuide
  } else {
    console.log('Detected desktop device!');
    guide.value = desktopGuide
  }
}

function showWarningMessege() {

  const userAgent = navigator.userAgent;

  if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
    warningBrowserSpecificMessege.value = '';
  } else if (userAgent.includes('Chrome') && userAgent.includes('iOS')) {
    warningBrowserSpecificMessege.value = $_('guide.messege.chrome_ios', 'Chrome na iOS nemusí podporovat instalaci PWA');
  } else if (userAgent.includes('Firefox') && userAgent.includes('Android')) {
    warningBrowserSpecificMessege.value = '';
  } else if (userAgent.includes('Firefox')) {
    warningBrowserSpecificMessege.value = $_('guide.messege.firefox_desktop', 'Firefox na desktopu nemusí podporovat instalaci PWA');
  } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    warningBrowserSpecificMessege.value = $_('guide.messege.safari_desktop', 'Safari na Macu nemusí podporovat instalaci PWA');
  } else {
    warningBrowserSpecificMessege.value = '';
  }
}

function installPWA() {
  console.log('Installing PWA...');

  if (deferredPrompt) {
    deferredPrompt.prompt(); // Show the install prompt
    console.log('Prompt shown');
    deferredPrompt.userChoice.then((choiceResult) => {
      console.log(`User choice: ${choiceResult.outcome}`);
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the PWA installation');
      } else {
        console.log('User dismissed the PWA installation');
      }
      deferredPrompt = null; // Reset the deferred prompt
    });
  } else {
    console.log('No deferred prompt available');
  }
}

// Swipe logic
let startX = 0
const handleTouchStart = (e) => {
  startX = e.touches ? e.touches[0].clientX : e.clientX
}

const handleTouchEnd = (e) => {
  const endX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX
  const diffX = endX - startX

  if (diffX > 50) {
    changeSlide((slide.value - 1 + guide.value.length) % guide.value.length) // Swipe right
  } else if (diffX < -50) {
    changeSlide((slide.value + 1) % guide.value.length) // Swipe left
  }
}

function changeSlide(index) {
  slide.value = index
}

const emits = defineEmits(['close'])

</script>
<template>
  <section ref="sectionRef">
    <div v-if="warningBrowserSpecificMessege" class="text-gray-600 warningMessege">
      <Info/>
      {{ warningBrowserSpecificMessege }}
    </div>
    <template v-if="showButton">
      <button @click="installPWA" class="installButton">
        <img :src="InstallDesktop" alt="">
        {{ $_('guide.button.install', 'Nainstalovat aplikaci') }}
      </button>
      <p class="text-base text-gray-600">{{ $_('guide.button.or_guide', 'Nebo postupujte podle návodu') }}</p>
    </template>
    <div v-if="guide?.length > 0 && elwidth <= 1024" class="container" @mousedown="handleTouchStart"
         @mouseup="handleTouchEnd"
         @touchstart="handleTouchStart" @touchend="handleTouchEnd">
      <div class="wholeWrap">
        <transition name="slide-fade" mode="out-in">
          <img :src="guide[slide].img" alt="" :key="slide">
        </transition>
        <div class="text">
          <p class="text-gray-600">{{ guide[slide].text }}</p>
        </div>
        <div class="buttonLike" v-if="guide[slide].buttonLikeText || guide[slide].buttonLikeImg">
          <img v-if="guide[slide].buttonLikeImg" :src="guide[slide].buttonLikeImg" alt="">
          <p v-if="guide[slide].buttonLikeText">{{ guide[slide].buttonLikeText }}</p>
        </div>
      </div>
      <div class="slideIndicator">
        <button v-if="guide.length > 1" v-for="i in guide.length" class="circle"
                :style="{ background: slide === i - 1 ? '#569709' : '#EBECEC' }"
                @click="changeSlide(i - 1)"></button>
      </div>
    </div>
    <div v-else class="desktopContainer">
      <div class="wholeWrap" v-for="item in guide" :key="item.text">
        <transition name="slide-fade" mode="out-in">
          <img :src="item.img" alt="">
        </transition>
        <div class="text">
          <p class="text-base text-gray-600">{{ item.text }}</p>
        </div>
        <div class="buttonLike" v-if="item.buttonLikeText || item.buttonLikeImg">
          <img v-if="item.buttonLikeImg" :src="item.buttonLikeImg" alt="">
          <p v-if="item.buttonLikeText">{{ item.buttonLikeText }}</p>
        </div>
      </div>
    </div>
  </section>
</template>
<style scoped>
section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
}

.warningMessege {
  background-color: #f0f0f0;
  width: fit-content;
  padding: 4px 14px;
  font-size: 0.9rem;
  border-radius: 9999px;
  fill: #000;
}

:deep(path) {
  fill: #616161;
}

.desktopContainer {
  display: flex;
  gap: 32px;
  width: 100%;
  justify-content: space-between;
  container-type: inline-size;
}

.container * {
  user-select: none;
  pointer-events: none;
  -webkit-user-drag: none;
}

.slideIndicator button {
  pointer-events: auto;
  /* Allow buttons to be clickable */
}

.wholeWrap > img {
  height: 150px;
}

.slideIndicator {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.slideIndicator button {
  transition: 0.5s all;
}

.circle {
  width: 10px;
  height: 10px;
  border-radius: 100%;
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
  min-height: 320px;
}

.wholeWrap {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  align-items: center;
  flex-direction: column;
}

.text {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  text-align: center;
}

.installButton {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  padding: 8px 16px;
  gap: 10px;
  fill: #fff;
  background-color: #569709;
  color: #fff;
  transition: all 0.5s;
}

.installButton:hover {
  background-color: #569709cc;
}

.buttonLike {
  display: flex;
  justify-content: center;
  user-select: none;
  align-items: center;
  border-radius: 100px;
  width: fit-content;
  padding: 8px 16px;
  margin: 0 auto;
  gap: 10px;
  background-color: #e3e3e3;
  fill: #fff;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(50px);
}

</style>
